import { useCallback, useState } from 'react';
import { isPropControlled } from '../helpers';
function useDateSelection(_ref) {
  let {
    initialDate,
    propsDate,
    propsOnChange,
    onFinalSelection,
    setShouldShowSelection
  } = _ref;
  const [stateDate, setStateDate] = useState(initialDate);
  const isDateControlled = isPropControlled(propsDate);
  const date = isDateControlled ? propsDate : stateDate;
  const onDateSelected = useCallback((_ref2, updateActiveMonths) => {
    let {
      selectable,
      date: newlySelectedDate
    } = _ref2;
    if (!selectable) {
      return;
    }
    if (!isDateControlled) {
      setStateDate(newlySelectedDate);
    }
    setShouldShowSelection === null || setShouldShowSelection === void 0 ? void 0 : setShouldShowSelection(true);
    propsOnChange === null || propsOnChange === void 0 ? void 0 : propsOnChange({
      date: newlySelectedDate
    });
    updateActiveMonths(false, newlySelectedDate);
    onFinalSelection();
  }, [isDateControlled, propsOnChange, onFinalSelection, setShouldShowSelection]);
  const resetSelection = useCallback(() => {
    if (!isDateControlled) {
      setStateDate(null);
    }
    propsOnChange === null || propsOnChange === void 0 ? void 0 : propsOnChange({
      date: null
    });
  }, [isDateControlled, propsOnChange]);
  return {
    date,
    onDateSelected,
    resetSelection
  };
}
export default useDateSelection;
//# sourceMappingURL=useDateSelection.js.map